import { CtaButton } from "@/components/Cta";

export const HostPricing = ({ stats }) => {
  const rows = [
    {
      range: "1–4 bays",
      price: `₹${stats.listing_fee_inr} per bay, per year`,
      note: "A house, a driveway, your own allotted bay",
    },
    {
      range: `Exactly ${stats.bundle_min_spots} bays`,
      price: `₹${stats.bundle_fee_inr.toLocaleString("en-IN")} a year, flat for the whole site`,
      note: `Cheaper than ${stats.bundle_min_spots} × ₹${stats.listing_fee_inr}`,
    },
    {
      range: `${stats.bundle_large_min_spots}–10 bays`,
      price: `₹${stats.bundle_large_fee_inr.toLocaleString("en-IN")} a year, flat for the whole site`,
      note: "However many bays in that range",
    },
    {
      range: `${stats.managed_free_min_spots}+ bays`,
      price: "Free, no annual fee",
      note: "Managed site — we work with your RWA or facility team directly",
    },
  ];

  return (
    <section data-testid="host-pricing" className="nb-section bg-surface2">
      <div className="nb-shell">
        <p className="nb-eyebrow">Host pricing</p>
        <h2 className="nb-h2 mt-4">What hosting costs</h2>
        <p className="nb-sub mt-4">One flat annual fee per site. No commission on your rent, ever.</p>

        <div className="mt-10 overflow-hidden rounded-nb2 border border-line">
          <table className="w-full border-collapse text-left">
            <caption className="sr-only">NightBay host listing fees by number of bays</caption>
            <thead>
              <tr className="bg-surface3">
                <th scope="col" className="px-4 py-3 font-head text-xs tracking-[0.12em] text-ink3">
                  Bays at one address
                </th>
                <th scope="col" className="px-4 py-3 font-head text-xs tracking-[0.12em] text-ink3">
                  You pay
                </th>
                <th
                  scope="col"
                  className="hidden px-4 py-3 font-head text-xs tracking-[0.12em] text-ink3 sm:table-cell"
                >
                  Note
                </th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r, i) => (
                <tr key={r.range} data-testid={`host-price-row-${i}`} className="border-t border-line">
                  <td className="px-4 py-4 text-sm text-ink2">{r.range}</td>
                  <td className="px-4 py-4 font-mono text-sm font-medium text-brand">{r.price}</td>
                  <td className="hidden px-4 py-4 text-sm text-ink3 sm:table-cell">{r.note}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {stats.free_slots_left > 0 && (
          <div
            data-testid="launch-offer"
            className="mt-8 rounded-nb2 border border-brand/50 bg-brand/10 p-6"
          >
            <h3 className="text-base text-brand">
              First 50 bays in Bengaluru list free for a full year.
            </h3>
            <p className="mt-2 text-sm text-ink2">
              No listing fee, no card needed.{" "}
              <span data-testid="free-slots-left" className="nb-num">
                {stats.free_slots_left}
              </span>{" "}
              of 50 still open.
            </p>
          </div>
        )}

        <p className="mt-8 text-sm text-ink3">
          That's the whole host side. We don't take a percentage of your rent, and we don't charge you
          per booking.
        </p>
        <div className="mt-8">
          <CtaButton side="host" testId="host-pricing-cta">
            I have a bay to rent out
          </CtaButton>
        </div>
      </div>
    </section>
  );
};
